// Event common content
export interface LoggerEventContent {
  eventType: string;
  eventSubType: LoggerEventEnum;
  pageId: string;
  requestDomain: string;
  endPoint: string;
  level: LoggerLogLevelEnum;
  userDeviceType: string;
  userLanguage: string;
  eventAdditionalInfo?:
    | LoggerUserActionOrNavigateEventContent
    | LoggerBackEndCallEventContent
    | LoggerForwardedContent
    | LoggerErrorContent
    | LoggerFunctionalErrorContent
    | LoggerPageEnteredContent;
}

// Button, link and navigation event content
export interface LoggerUserActionOrNavigateEventContent {
  id: string;
}

// Back-end call event content
export interface LoggerBackEndCallEventContent {
  backEndUrl: string;
  httpMethod: string;
  httpStatusCode: number;
  errorCode?: string;
  executionTime: number;
  backEndEndpoint: string;
}

// Technical error content
export interface LoggerErrorContent {
  errorStackTrace: string;
}

// Functional error content
export interface LoggerFunctionalErrorContent {
  description: string; // Description of the error
  userFeedbackMessage: string; // Feed-back message user received
}

// Page entered content
export interface LoggerPageEnteredContent {
  previousPageId: string;
}

// Forwared content
export interface LoggerForwardedContent {
  forwardUrl: string;
}

/**
 * DipseDynamicEventLogContent is for providing values which are provided by the source application
 */
export interface DynamicEventLogContent {
  eventType: string;
  userDeviceType: LoggerDeviceType;
  userLanguage: string;
  logEndpointURL: string;
}

export enum LoggerLogLevelEnum {
  INFO = 'INFO',
  DEBUG = 'DEBUG',
  WARN = 'WARN',
  ERROR = 'ERROR',
}

/**
 * DipseLoggerEventEnum is for using to track user activities based on the happening event
 */
export enum LoggerEventEnum {
  PAGE_ENTERED = 'PAGE_ENTERED',
  PAGE_EXITED = 'PAGE_EXITED',
  FORWARD = 'FORWARD', // Forwards to external application (ex: URP)
  USER_ACTION = 'USER_ACTION', // Button or link clicked
  BACKEND_CALL = 'BACKEND_CALL',
  ERROR = 'ERROR', // technical error
  FUNCTIONAL_ERROR = 'FUNCTIONAL_ERROR', // Error related to functional context (ex: party not found)
  SESSION_EXPIRED = 'SESSION_EXPIRED', // Front-end detected the HTTP session expired
}

export enum LoggerDeviceType {
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  WEB = 'WEB',
}
